<template>
  <div class="PasswordForm">
    <div>
      <h3>{{ title }}</h3>
    </div>
    <el-form 
      ref="passwordForm" 
      :model="form" 
      :rules="rules" 
      inline 
      size="large">
      <el-form-item prop="password">
        <el-input
          type="password"
          prefix-icon="el-icon-lock"
          v-model="form.password"
          placeholder="비밀번호"
          ref="password"
          class="m-auto"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password_re">
        <el-input
          type="password"
          prefix-icon="el-icon-lock"
          v-model="form.password_re"
          placeholder="비밀번호 확인"
          @keyup.enter.native="handleClickSubmit"
          class="m-auto"
        ></el-input>
      </el-form-item>
      <div class="submit m-auto">
        <el-button
          type="primary"
          size="large"
          @click="handleClickSubmit"
          class="submit"
        >확인</el-button>
        <el-button
          size="large"
          @click="handleClickCancel"
          class="submit"
        >취소</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
// import store from "store";

export default {
  name: "PasswordForm",
  data() {
    return {
      title: '비밀번호 변경',
      form: {
        password: "",
        password_re: ""
      },
      rules: {
        password: [
          { required: true, message: "비밀번호를 입력해 주세요." },
          { min: 4, message: '최소 4자 이상 입력해 주세요.' }
        ],
        password_re: [{ required: true, message: "비밀번호를 다시 한 번 입력해 주세요." }],
      },
    };
  },
  props: {
    account: {
      type: String,
      required: true
    },
  },
  methods: {
    doSetPassword() {
      let params = { account: this.account, password: this.form.password};
      this.api.updateUserPassword(params).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, '비밀번호가 설정되었습니다. 로그인해 주세요.')
        this.$emit('completed')
      });
    },
    handleClickCancel() {
      this.$emit('cancel')
    },
    handleClickSubmit() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return;
        this.doSetPassword();
      });
    },
  }
};
</script>
